module.exports = __webpack_public_path__ + "img/th.6c6cdace.png";